// $(function() {
//     $('.quantity-selector__button').on('click', function() {
//         var variantId = $(this).attr("data-variant");
        
//         $.ajax({
//             type: 'POST',
//             url: '/cart',
//             data: {
//                 quantity: 1,
//                 id: variantId
//             },
//             dataType: 'json',
//             success: function(data) {
//                 // Update cart count in header
//                 updateCartCount(function(cart) {
//                     // Display updated cart count in an alert
//                     alert("Cart count updated to: " + cart.item_count);
//                 });
//             },
//             error: function(xhr, status, error) {
//                 // Handle errors if needed
//                 console.error('Error updating cart:', error);
//             }
//         });
//     });

//     // Function to update cart count in header and execute callback
//     function updateCartCount(callback) {
//         $.ajax({
//             type: 'GET',
//             url: '/cart.js',
//             dataType: 'json',
//             success: function(cart) {
//                 // Update the cart count in the header
//                 $('.header__cart-count').html(cart.item_count);
//                 // Execute callback with updated cart data
//                 if (typeof callback === 'function') {
//                     callback(cart);
//                 }
//             },
//             error: function(xhr, status, error) {
//                 // Handle errors if needed
//                 console.error('Error fetching cart data:', error);
//             }
//         });
//     }

//     // Initial call to update cart count on page load
//     updateCartCount(function(cart) {
//         // Display initial cart count in an alert
//         alert("Initial cart count: " + cart.item_count);
//     });
// });


$(document).ready(function () {
  // Header Height get js
    const header = $('.new-header');
    const headerHeight = header.outerHeight();
    $('.collection__wrapper .layout .layout__section--secondary .card').css('top', headerHeight + 'px');
    console.log(`Header height: ${headerHeight}px`);
  
  // Back to top
var amountScrolled = 200;
var amountScrolledNav = 25;

$(window).scroll(function() {
  if ( $(window).scrollTop() > amountScrolled ) {
    $('button.back-to-top').addClass('show');
  } else {
    $('button.back-to-top').removeClass('show');
  }
});

$('button.back-to-top').click(function() {
  $('html, body').animate({
    scrollTop: 0
  }, 800);
  return false;
});
  
  // $(document).on("click", "li.has-children > span.down-arrow", function () {
  //   console.log("menu arrow clicked");
  //   e.preventDefault();
  //   var $submenuWrapper = $(this).closest("li.has-children");
  //   var $submenu = $submenuWrapper.find("> ul");

  //   if ($submenu.is(":visible")) {
  //     $submenu.slideUp("slow", function () {
  //       $submenuWrapper.removeClass("active");
  //     });
  //   } else {
  //     $("li.has-children > ul").slideUp("slow"); // Close other open submenus
  //     $("li.has-children").removeClass("active"); // Remove active class from other menu items

  //     $submenu.slideDown("slow", function () {
  //       $submenuWrapper.addClass("active");
  //     });
  //   }
  // });
  // $(document).on(
  //   "click",
  //   "li.has-children > a > span.down-arrow",
  //   function (e) {
  //     e.preventDefault();
  //     var $submenuWrapper = $(this).closest("li.has-children");
  //     var $submenu = $submenuWrapper.find("> li.has-children > ul");

  //     if ($submenu.is(":visible")) {
  //       $submenu.slideUp("slow", function () {
  //         $submenuWrapper.removeClass("active");
  //       });
  //     } else {
  //       $("li.has-children > ul").slideUp("slow"); // Close other open submenus
  //       $("li.has-children").removeClass("active"); // Remove active class from other menu items

  //       $submenu.slideDown("slow", function () {
  //         $submenuWrapper.addClass("active");
  //       });
  //     }
  //   }
  // );
  $(document).on("click","li.has-children > a > span.down-arrow",function (e) {
      console.log("arrow clicked");
      e.preventDefault();
      var $submenuWrapper = $(this).closest("li.has-children");
      var $submenu = $submenuWrapper.find("> ul");

      if ($submenu.is(":visible")) {
        $submenu.slideUp("slow", function () {
          $submenuWrapper.removeClass("active");
        });
      } else {
        $("li.has-children > ul").slideUp("slow"); // Close other open submenus
        $("li.has-children").removeClass("active"); // Remove active class from other menu items

        $submenu.slideDown("slow", function () {
          $submenuWrapper.addClass("active");
        });
      }
    });
  $(document).on("click","li.has-sub-children > a > span.down-arrow",function (e) {
      console.log("arrow clicked");
      e.preventDefault();
      var $submenuWrapper = $(this).closest("li.has-sub-children");
      var $submenu = $submenuWrapper.find("> ul");

      if ($submenu.is(":visible")) {
        $submenu.slideUp("slow", function () {
          $submenuWrapper.removeClass("active");
        });
      } else {
        $("li.has-sub-children > ul").slideUp("slow"); // Close other open submenus
        $("li.has-sub-children").removeClass("active"); // Remove active class from other menu items

        $submenu.slideDown("slow", function () {
          $submenuWrapper.addClass("active");
        });
      }
    });
  $(window).scroll(function () {
      var sc = $(window).scrollTop()
      if (sc > 50) {
          $(".new-header").addClass("fixed-header");
      } else {
          $(".new-header").removeClass("fixed-header");
      }
  });
  $(".js-banner-slider").slick({
    slidesToShow: 1,
    infinite: false,
    slidesToScroll: 1,
    autoplay: false,
    dots: true,
  });
  $(".js-popular-slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    focusOnSelect: true,
    infinite: false,
    draggable: false,
    appendArrows: ".popular-arrow",
    prevArrow:
      '<button class="slick-prev slick-arrow"><svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 8L1 8" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 1L1 8L8 15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:
      '<button class="slick-next slick-arrow"><svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8L20 8" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 1L20 8L13 15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  setTimeout(function () {
    console.log("set timeout");
    $(".js-recent-view").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      focusOnSelect: true,
      infinite: false,
      draggable: false,
      appendArrows: ".recentview-arrow",
      prevArrow:
        '<button class="slick-prev slick-arrow"><svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 8L1 8" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 1L1 8L8 15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button class="slick-next slick-arrow"><svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8L20 8" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 1L20 8L13 15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }, 500);

  $(".new-header__toggle span").click(function () {
    $("body").addClass("menu-open");
    $(".new-header__menu").addClass("menu-open");
  });
  $(".new-header__closeicon span").click(function () {
    $("body").removeClass("menu-open");
    $(".new-header__menu").removeClass("menu-open");
  });
  $(".new-announcement__barwrapper").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 4000,
    pauseOnHover: false,
    cssEase: "linear",
    variableWidth: true,
  });
  $(".accordion .toggle").click(function (e) {
    e.preventDefault();

    let $this = $(this);

    if ($this.next().hasClass("show")) {
      $this.next().removeClass("show");
      $this.next().slideUp(350);
    } else {
      $this.parent().parent().find("li .inner").removeClass("show");
      $this.parent().parent().find("li .inner").slideUp(350);
      $this.next().toggleClass("show");
      $this.next().slideToggle(350);
    }
  });
  $(".accordion li a").on("click", function () {
    $(this).parent().siblings().removeClass("active");
    $(this).parent().toggleClass("active");
  });

  $(".slider-for").slick({
    slidesToShow: 1,
    lazyLoad: "ondemand",
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    infinite: false,
    asNavFor: ".slider-nav",
  });
  $(".slider-nav").slick({
    slidesToShow: 5,
    infinite: false,
    lazyLoad: "ondemand",
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    arrows: false,
    focusOnSelect: true,
    prevArrow:
      '<button class="slick-prev slick-arrow"><i class="demo-icon icon-left-open-big"></i></button>',
    nextArrow:
      '<button class="slick-next slick-arrow"><i class="demo-icon icon-right-open-big"></i></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          rows: 0,
          slidesPerRow: 0,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          arrows: true,
          dots: false,
        },
      },
    ],
  });

  $(".qty-input i").on("click", function () {
    val = parseInt($(this).parent().find("input").val());

    if ($(this).hasClass("less")) {
      val = val - 1;
    } else if ($(this).hasClass("more")) {
      val = val + 1;
    }

    if (val < 1) {
      val = 1;
    }

    $(this).parent().find("input").val(val);
  });

  setTimeout(function () {
    console.log("set timeout");
    $(
      ".custom-product-recommandation .product-recommendations .product-list"
    ).slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      focusOnSelect: true,
      infinite: false,
      draggable: false,
      appendArrows: ".popular-arrows",
      prevArrow:
        '<button class="slick-prev slick-arrow"><svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 8L1 8" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 1L1 8L8 15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button class="slick-next slick-arrow"><svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8L20 8" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 1L20 8L13 15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }, 500);
});
